import { render } from "./showBrokersComponent.vue?vue&type=template&id=4e7012de&scoped=true"
import script from "./showBrokersComponent.vue?vue&type=script&lang=js"
export * from "./showBrokersComponent.vue?vue&type=script&lang=js"

import "./showBrokersComponent.vue?vue&type=style&index=0&id=4e7012de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7012de"]])

export default __exports__